import React from "react";
import { connect } from "react-redux";

// import "./Tour.css";
// import { HOME, PROJECT_HOME } from "App/Routes";
import TourPage from "./TourPage";
import { REQUIRE_LOGIN, ENABLE_LOGIN_HOME } from "config";
import {
  PROJECT_LOGIN_HOME,
  PROJECT_LOGIN,
  LOGIN_HOME,
  LOGIN
} from "App/Routes";
import urlServices from "services/urlServices";
import Router from "router";

import {
  mapDispatchToProps,
  TourContainer
} from "components/shared/Tour/TourContainer";

export const mapStateToProps = (state, ownProps) => {
  return {
    projectId: state.projectId,
    language: state.language,
    sessionKey: state.sessionKey,
    userId: state.user ? state.user.id : null
  };
};

export class AhmaTourContainer extends TourContainer {
  handleCloseClick = e => {
    e.preventDefault();
    if (
      REQUIRE_LOGIN &&
      !this.props.userId &&
      !this.props.sessionKey &&
      !urlServices.isAccountAccessPage()
    ) {
      if (this.props.projectId && ENABLE_LOGIN_HOME) {
        Router.replaceAndNavigate(
          PROJECT_LOGIN_HOME.format(this.props.projectId)
        );
      } else if (this.props.projectId) {
        Router.replaceAndNavigate(PROJECT_LOGIN.format(this.props.projectId));
      } else if (ENABLE_LOGIN_HOME) {
        Router.replaceAndNavigate(LOGIN_HOME);
      } else {
        Router.replaceAndNavigate(LOGIN);
      }
    } else {
      Router.replaceAndNavigate(this.state.redirectUrl);
    }
  };

  render() {
    return (
      <TourPage
        projectId={this.props.projectId}
        redirectUrl={this.state.redirectUrl}
        completedTour={this.state.completedTour}
        slidesLength={this.state.slidesLength}
        handleCloseClick={this.handleCloseClick}
        setSlidesLength={this.setSlidesLength}
        setCompletedTour={this.setCompletedTour}
        language={this.props.language}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AhmaTourContainer);
